module.exports = __webpack_public_path__ + "static/img/icon02.b1bfe9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture/icon02.png
// module id = 4x/f
// module chunks = 1